// Generated from onramp-navigation-maifest.yml. Do not edit.
export const fundingNavigationManifest = {
    version: 1,
    methods: {
        card: {
            flow: 'card_checkout',
            payment_screen: 'card',
        },
        apple_pay: {
            flow: 'wallet_checkout',
            payment_screen: 'apple_pay',
        },
        google_pay: {
            flow: 'wallet_checkout',
            payment_screen: 'google_pay',
        },
        cex_connect: {
            flow: 'exchange_checkout',
            payment_screen: 'exchange_approve',
        },
        crypto_deposit: {
            flow: 'crypto_deposit',
            payment_screen: 'deposit_address',
        },
        wallet_connect: {
            flow: 'connected_wallet',
            payment_screen: 'wallet_widget',
        },
        paypal: {
            flow: 'hosted_checkout',
            payment_screen: 'hosted_widget',
        },
        venmo: {
            flow: 'hosted_checkout',
            payment_screen: 'hosted_widget',
        },
        revolut_pay: {
            flow: 'hosted_checkout',
            payment_screen: 'hosted_widget',
        },
        moonpay_balance: {
            flow: 'hosted_checkout',
            payment_screen: 'hosted_widget',
        },
        sepa: {
            flow: 'bank_transfer_checkout',
            payment_screen: 'bank_transfer_instructions',
        },
        gbp_bank_transfer: {
            flow: 'hosted_checkout',
            payment_screen: 'hosted_widget',
        },
        gbp_open_banking_payment: {
            flow: 'hosted_checkout',
            payment_screen: 'hosted_widget',
        },
        pix_instant_payment: {
            flow: 'hosted_checkout',
            payment_screen: 'hosted_widget',
        },
    },
    exchange_checkout: {
        initial: 'exchanges',
        screens: {
            exchanges: {
                back: 'methods',
            },
            exchange_auth: {
                back: 'exchanges',
            },
            exchange_balances: {
                back: 'exchanges',
            },
            source: {
                back: 'exchange_balances',
            },
            amount: {
                back: 'source',
            },
            exchange_approve: {
                back: 'amount',
            },
            exchange_2fa: {
                back: 'exchange_approve',
            },
            status: {
                back: 'methods',
            },
        },
        events: {
            open_exchange_picker: 'exchanges',
            connector_selected: 'exchange_auth',
            authorization_complete: 'exchange_balances',
            balance_selected: 'source',
            source_selected: 'amount',
            amount_confirmed: 'exchange_approve',
            withdrawal_action_required: 'exchange_2fa',
            withdrawal_submitted: 'status',
            submission_unknown: 'status',
            connection_rejected: 'exchanges',
            connection_expired: 'exchange_auth',
            change_exchange: 'exchanges',
            change_balance: 'exchange_balances',
            edit_amount: 'amount',
        },
    },
    entry: {
        initial: 'deposit',
        events: {
            open_manual_transfer: 'manual_transfer',
            open_crypto_deposit: 'crypto_deposit',
            open_connected_wallet: 'connected_wallet',
            open_history: 'history',
            open_receipt: 'receipt',
            new_deposit: 'deposit',
            new_withdraw: 'withdraw',
        },
        receipt_back: {
            deposit: 'deposit',
            withdraw: 'withdraw',
            history: 'history',
        },
        history_back: 'deposit',
        host_back: {
            manual_transfer: 'deposit',
            crypto_deposit: 'deposit',
            connected_wallet: 'deposit',
        },
        close: 'preserve',
    },
    host_routes: {
        manual_transfer: {
            screen: 'manual_transfer',
            alternate_route: 'crypto_deposit',
        },
    },
    crypto_deposit: {
        initial: 'source',
        screens: {
            source: {
                back: 'methods',
            },
            deposit_address: {
                back: 'source',
            },
            checking_transfer: {
                back: 'deposit_address',
            },
            source_detected: {
                back: 'methods',
            },
            below_minimum: {
                back: 'methods',
            },
            review_hold: {
                back: 'methods',
            },
            processing: {
                back: 'methods',
            },
            complete: {
                back: 'methods',
            },
            wrong_network: {
                back: 'source',
            },
            instructions_expired: {
                back: 'methods',
            },
            late_transfer: {
                back: 'methods',
            },
            multiple_transfers: {
                back: 'methods',
            },
            route_failed: {
                back: 'methods',
            },
            refund: {
                back: 'methods',
            },
            offline: {
                back: 'methods',
            },
        },
        events: {
            route_selected: 'deposit_address',
            reconcile_requested: 'checking_transfer',
            transfer_not_found: 'checking_transfer',
            transfer_detected: 'source_detected',
            below_minimum: 'below_minimum',
            review_held: 'review_hold',
            conversion_started: 'processing',
            delivery_confirmed: 'complete',
            network_mismatch: 'wrong_network',
            instructions_expired: 'instructions_expired',
            late_transfer_detected: 'late_transfer',
            multiple_transfers_detected: 'multiple_transfers',
            conversion_failed: 'route_failed',
            refund_confirmed: 'refund',
            connection_lost: 'offline',
        },
    },
    connected_wallet: {
        initial: 'wallets',
        screens: {
            wallets: {
                back: 'methods',
            },
            wallet_widget: {
                back: 'wallets',
            },
            status: {
                back: 'methods',
            },
        },
        events: {
            open_wallet_connect: 'wallets',
            start_wallet_connection: 'wallet_widget',
            transfer_submitted: 'status',
            submission_unknown: 'status',
            delivery_confirmed: 'status',
        },
    },
    checkout: {
        screens: {
            methods: {
                back: null,
            },
            profile: {
                back: 'methods',
            },
            amount: {
                back: 'methods',
            },
            card_entry: {
                back: 'amount',
            },
            verification: {
                back: 'amount',
            },
            review: {
                back: 'amount',
            },
            payment: {
                back: 'methods',
            },
            bank_transfer_instructions: {
                back: 'status',
            },
            challenge: {
                back: 'review',
            },
            customer_verification: {
                back: 'methods',
            },
            connection_required: {
                back: 'methods',
            },
            connect: {
                back: 'connection_required',
            },
            terms: {
                back: 'methods',
            },
            unavailable: {
                back: 'methods',
            },
            status: {
                back: 'methods',
            },
        },
        events: {
            limit_verification_return: 'amount',
            limit_verification_complete: null,
            profile_requested: 'profile',
            method_selected: 'amount',
            bank_transaction_created: 'bank_transfer_instructions',
            bank_instructions_dismissed: 'status',
            card_entry_required: 'card_entry',
            card_entry_failed: 'card_entry',
            card_unavailable: 'methods',
            change_method: 'methods',
            contacts_required: 'verification',
            customer_verification_required: 'customer_verification',
            quote_ready: 'review',
            quote_failed: 'amount',
            quote_expired: 'review',
            quote_challenge: 'challenge',
            attempt_executable: 'payment',
            attempt_already_exists: 'status',
            payment_unavailable: 'unavailable',
            payment_uncertain: 'status',
            payment_complete: 'status',
            payment_challenge: 'challenge',
            resume_challenge: 'challenge',
            verification_pending: 'review',
            connect_requested: 'connect',
            connection_required: 'connection_required',
            terms_required: 'terms',
            connection_unavailable: 'unavailable',
            edit_amount: 'amount',
            session_refreshed: null,
            authentication_complete: null,
            verification_complete: null,
        },
    },
    contact: {
        back: {
            email: 'amount',
            email_code: 'email',
            phone: 'email',
            phone_code: 'phone',
            consent: 'email',
        },
        screens: {
            email: 'email',
            phone: 'phone',
            code: 'code',
            consent: 'consent',
            ready: 'ready',
            unavailable: 'unavailable',
            refresh: 'refresh',
        },
    },
    kyc: {
        screens: {
            verified_active: 'identity_complete',
            onboarding_not_created: 'provider_verification',
            document_or_selfie_required: 'provider_verification',
            phone_required: 'phone_verification',
            details_or_pending: 'details',
        },
    },
    payment_recovery: {
        common: {
            ready: 'ignore',
            authorizing: 'ignore',
            transaction_created: 'ignore',
            challenge_required: 'challenge',
            reconciling: 'status',
        },
        with_transaction: {
            widget_closed: 'status',
            provider_failed: 'status',
        },
        before_transaction: {
            widget_closed: 'review',
            provider_failed: 'review',
        },
        with_attempt: {
            sheet_cancelled: 'resume_payment',
            second_factor_required: 'resume_payment',
            requote_with_continuation: 'quote',
            otherwise: 'status',
        },
        before_attempt: {
            requote_required: 'quote',
            session_refresh_required: 'refresh_session',
            connection_required: 'connect',
            submission_unknown: 'review',
            verification_pending: 'review',
            otherwise: 'amount',
        },
    },
    offramp: {
        methods: {
            ach_bank_transfer: {
                flow: 'hosted_sell',
            },
            sepa_bank_transfer: {
                flow: 'hosted_sell',
            },
            gbp_bank_transfer: {
                flow: 'hosted_sell',
            },
            gbp_open_banking_payment: {
                flow: 'hosted_sell',
            },
            credit_debit_card: {
                flow: 'hosted_sell',
            },
            paypal: {
                flow: 'hosted_sell',
            },
            venmo: {
                flow: 'hosted_sell',
            },
            moonpay_balance: {
                flow: 'hosted_sell',
            },
            cash_app: {
                flow: 'hosted_sell',
            },
            manual_withdraw: {
                flow: 'manual_withdraw',
            },
        },
        screens: {
            payouts: {
                back: null,
            },
            recipient: {
                back: 'payouts',
            },
            amount: {
                back: 'payouts',
            },
            review: {
                back: 'amount',
            },
            payout_account: {
                back: 'review',
            },
            hosted: {
                back: 'review',
            },
            wallet_sign: {
                back: 'review',
            },
            requote: {
                back: 'status',
            },
            status: {
                back: 'payouts',
            },
        },
        events: {
            method_selected: 'amount',
            manual_selected: 'recipient',
            recipient_valid: 'amount',
            quote_ready: 'review',
            hosted_required: 'payout_account',
            submission_reported: 'status',
            submission_unknown: 'status',
        },
    },
    direct_token_purchase: {
        initial: 'amount',
        close: 'preserve',
        preferred_method: 'entry_method',
        change_method: 'methods',
        receipt_back: 'origin',
    },
};
